import { parsePhoneNumberFromString } from 'libphonenumber-js'

const regex = /^[A-Za-z0-9]+$/

export const validateFlightNumber = (flightNumber: string) =>
  regex.test(flightNumber)

const isQatariPhone = (phoneNumber: string) => phoneNumber.startsWith('+974')

export const validatePhoneNumber = (phoneNumber: string) => {
  const normalized = phoneNumber.replace(/[\s()-]/g, '')

  if (isQatariPhone(normalized)) {
    return /^(?:\+974)?[3567]\d{7}$/.test(normalized)
  }

  const parsed = parsePhoneNumberFromString(normalized)

  if (!parsed) return false

  return parsed.isPossible() && parsed.isValid()
}
